export default {
    seo: {
        home: {
            title: "کد پرو - آموزش برنامه نویسی به روش تعاملی",
            description: "پلتفرم آموزش برنامه نویسی..."
        },
        notFound: {
            title: "صفحه مورد نظر پیدا نشد - کدپرو",
            description: "صفحه‌ای که به دنبال آن هستید وجود ندارد."
        }
    },

    home: {
        heading: "یادگیری برنامه‌نویسی به سبک تمرین‌محور",
        subtitle: "درسنامه‌های کوتاه و آموزنده، تمرین کد زدن و پروژه‌های واقعی، شروع رایگان!",
        downloadBazaar: "دانلود از بازار",
        downloadMyket: "دانلود از مایکت",
        downloadUrlBazaar: "https://cafebazaar.ir/app/app.codepro.android.bazaar",
        downloadUrlMyket: "https://myket.ir/app/app.codepro.android.myket"
    },

    codepro: {
        why: 'هدف از ساختن پلتفرم کدپرو این است که آموزش و یادگیری برنامه‌نویسی سریع‌تر و آسان‌تر شود و تجربه‌ای عالی برای کاربران باشد.',
        social: 'شبکه‌اجتماعی',
        support: 'پشتیبانی',
        terms: 'قوانین و مقررات',
        feedback: 'نظرسنجی',
        usefullinks: 'لینک‌های مفید',
        blog: 'بلاگ',
        allrights: 'تمامی حقوق',
        reserved: 'محفوظ می‌باشد.',
    },

    menu: {
        navItems: [
            { label: 'بلاگ', to: '/fa/blog/' },
        ]
    },

    notFound: {
        heading: "صفحه مورد نظر پیدا نشد...",
        imageAlt: "صفحه پیدا نشد"
    },

    blog: {
        title: 'بلاگ کدپرو: مکانی برای شناخت بهتر دنیای کامپیوتر',
        not_found: 'هیچ مقاله ای پیدا نشد...',
        tableOfContents: 'فهرست مطالب',
        team: 'کدپرو',
        lastUpdated: 'آخرین بروزرسانی',
        readTime: 'زمان برای خواندن',
        share: 'اشتراک گذاری',
        minutes: 'دقیقه',
    },


    utils: {
        after: 'بعدی',
        before: 'قبلی',
    }
}